import type { ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'

interface MainLayoutProps {
  children: ReactNode
}

export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--background-secondary)' }}>
      <Header />
      <div className="relative flex-1">
        <main className="container mx-auto px-4 py-8">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  )
}
